<div class="container-tig">
    <div class="title">
        <h4>使用方法</h4>
    </div>
    <div class="help-cont ">
        <a class="help-c-item cont-item " [routerLink]="['/usageMethod/install']" routerLinkActive="help-link-active">
            <h4>安装指南</h4>
            <p _ngcontent-yyx-c20="" class="title-b"></p>
        </a>
        <a class="help-c-item cont-item" [routerLink]="['/usageMethod/office']" routerLinkActive="help-link-active">
            <h4>嵌入办公软件</h4>
            <p _ngcontent-yyx-c20="" class="title-b"></p>
        </a>
        <a class="help-c-item cont-item" [routerLink]="['/usageMethod/web']" routerLinkActive="help-link-active">
            <h4>嵌入网页</h4>
            <p _ngcontent-yyx-c20="" class="title-b"></p>
        </a>
        <a class="help-c-item cont-item" [routerLink]="['/usageMethod/applets']" routerLinkActive="help-link-active">
            <h4>嵌入小程序</h4>
            <p _ngcontent-yyx-c20="" class="title-b"></p>
        </a>
        <!-- <div class="help-c-item cont-item not-allowed">
            <h4>嵌入软件</h4>
            <p _ngcontent-yyx-c20="" class="title-b"></p>
        </div>

        <div class="help-c-item cont-item not-allowed">
            <h4>嵌入APP</h4>
            <p _ngcontent-yyx-c20="" class="title-b"></p>
        </div>
        <div class="help-c-item cont-item not-allowed">
            <h4>嵌入软件开发</h4>
            <p _ngcontent-yyx-c20="" class="title-b"></p>
        </div> -->
    </div>
    <router-outlet></router-outlet>
</div>